import { render, staticRenderFns } from "./ZmmFooter.vue?vue&type=template&id=98e047ba"
import script from "./ZmmFooter.vue?vue&type=script&lang=js"
export * from "./ZmmFooter.vue?vue&type=script&lang=js"
import style0 from "./ZmmFooter.vue?vue&type=style&index=0&id=98e047ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports